// extracted by mini-css-extract-plugin
export default {"postCommentListItemImage":"PostCommentListItem_postCommentListItemImage__LLGBM","postCommentListItemUser":"PostCommentListItem_postCommentListItemUser__DfrHI"};